import axios from "axios";

export const BACKEND_URL = '';
export const API = '/api';

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
        "X-API-Key": process.env.REACT_APP_API_KEY
    }
});

export function formatApiError (err) {
    const detail = err?.response?.data?.detail;
    if (!detail) {
        return (
            err?.message || "কিছু একটি সমস্যা হয়েছে"
        );

    }

    if (typeof detail === "string") {
        return detail;
    }

    if (Array.isArray(detail)) {
        return detail
            .map(
                e => e?.msg ||
                    JSON.stringify(e)
            )
            .join(" ");
    }
    return String(detail);
}